import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import UserInfo from './UserInfo';
import PasswordSecurity from './PasswordSecurity';
import NotificationList from './NotificationList';
import PrivacyPolicy from './PrivacyPolicy';
import SettingsSidebar from './SettingsSidebar';

const SettingsSection: React.FC = () => {
  return (
    <div className="flex bg-gray-50 min-h-full">
      <SettingsSidebar />
      <div className="flex-1">
        <Outlet />
      </div>
    </div>
  );
  {
    /*const [activeTab, setActiveTab] = useState('User Info');

  const renderContent = () => {
    switch (activeTab) {
      case 'User Info':
        return <UserInfo />;
      case 'Password & Security':
        return <PasswordSecurity />;
      case 'Notifications':
        return <NotificationList />;
      case 'Privacy Policy':
        return <PrivacyPolicy />;
      default:
        return <UserInfo />;
    }
  };

  return (
    <div className="flex bg-gray-50 min-h-full">
      <SettingsSidebar activeTab={activeTab} setActiveTab={setActiveTab} />
      <div className="flex-1">{renderContent()}</div>
    </div>
  );*/
  }
};

export default SettingsSection;
